import Icon from "@ailibs/feather-react-ts/dist/Icon";
import React from "react";
import CountUp from "react-countup";
import { Card, CardBody, Col, Row } from "reactstrap";


interface Props {
  WidgetData?: any;
  WidgetTitle?: any;
  color?: string;
  suffix?: string;
  icon?: any;
  decimals?: number
}

export const NewHomeWidgetCampaign = (props: Props) => {
  const { color } = props;
  return (
    <Card style={{ minHeight: "5em", minWidth: 200, margin: 0 }} className=" on-hover shadow-none">
      <CardBody style={{ padding: "0.4rem 1rem", display: "flex", gap: "2rem", alignItems: "center", justifyContent: "center" }}>
        <Row style={{ width: "100%", display: "flex", flexWrap: "wrap" }}>
          <div style={{
            // background: `${color || "rgb(29, 161, 212)"}`,
            width: "5em",
            // height: "5em",
            alignSelf: "center",
            minWidth: "4em",
            display: "flex", justifyContent: "center", alignItems: "center",
            borderRadius: "5%",
            aspectRatio: "1/1",
            position: "relative",
            // overflow: "hidden",
            flexShrink: 0
          }}>

            {/* Circulos */}
            {/* <section>
              <div style={{ position: "absolute", right: "-25%", bottom: "-45%", zIndex: 0 }}>
                <div style={{
                  background: "transparent", width: "4em", height: "4em", borderRadius: "50%", position: "relative", boxShadow: " 0 0 0 8px rgba(255, 255, 255, 0.09)"
                }}>
                  <div style={{
                    background: "transparent",
                    width: "2.6em",
                    height: "2.6em",
                    borderRadius: "50%",
                    position: "absolute",
                    boxShadow: " 0 0 0 8px rgba(255, 255, 255, 0.09)",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)"
                  }}>
                    <div style={{
                      background: "transparent",
                      width: "1em",
                      height: "1em",
                      borderRadius: "50%",
                      position: "absolute",
                      boxShadow: " 0 0 0 8px rgba(255, 255, 255, 0.09)",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%,-50%)"
                    }}>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ position: "absolute", right: "-50%", top: "0", zIndex: 0 }}>
                <div style={{
                  background: "transparent", width: "4em", height: "4em", borderRadius: "50%", position: "relative", boxShadow: " 0 0 0 8px rgba(255, 255, 255, 0.09)"
                }}>
                  <div style={{
                    background: "transparent",
                    width: "2.6em",
                    height: "2.6em",
                    borderRadius: "50%",
                    position: "absolute",
                    boxShadow: " 0 0 0 8px rgba(255, 255, 255, 0.09)",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)"
                  }}>
                    <div style={{
                      background: "transparent",
                      width: "1em",
                      height: "1em",
                      borderRadius: "50%",
                      position: "absolute",
                      boxShadow: " 0 0 0 8px rgba(255, 255, 255, 0.09)",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%,-50%)"
                    }}>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}
            {/*  */}
            {/* <div style={{ zIndex: 1 }}> */}
            {props.icon ? props.icon : <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" className="bi bi-cash" viewBox="0 0 16 16">
              <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
              <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z" />
            </svg>}
            {/* </div> */}

          </div>
          <section className="homeCards-text" style={{ width: 0, justifyContent: "center", alignItems: "center", flexDirection: "column", display: "flex", flexGrow: 1 }}>
            <p style={{ display: "inline-block", fontSize: "min(max(16px, 1rem + (1vw - 9px) * 0.3922), 20px)", marginBottom: 0, fontWeight: 300 }}>
              {props.WidgetTitle || "Titulo"}
            </p>
            <h3 className="mb-2 d-flex align-items-center">
              <CountUp
                start={0}
                formattingFn={(number) => `${number.toLocaleString("es-AR")}${props.suffix || ""}`}
                end={props.WidgetData || 0}
                decimals={props.decimals || 0}
                duration={1}
                suffix={props.suffix || ""}
                style={{ fontSize: "1.8rem", fontWeight: "300" }}
              />
            </h3>
          </section>

        </Row>

      </CardBody>
    </Card>




    // <Card style={{ height: 120 }} className=" on-hover shadow-none">
    //   <CardBody style={{ padding: "1em 1em" }}>
    //     <Row>
    //       <Col sm={4} style={{
    //         display: "grid",
    //         padding: 0,
    //         placeContent: "center",
    //         gridTemplate:""
    //       }}>
    //         <div style={{
    //           background: "red",
    //           width: "5em",
    //           height: "5em",
    //           display: "grid", placeContent: "center",
    //           borderRadius: "5%",
    //           aspectRatio: "1/1"
    //         }}>
    //           <Icon name="airplay" color="white"></Icon>
    //         </div>
    //       </Col>
    //       <Col sm={8} style={{ paddingLeft: "1rem", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
    //         <div style={{ display: "inline-block", fontSize: "16px", color: "#e2f8f9" }}>
    //           Total disponible
    //         </div>
    //         <h3 className="font-weight-bold mb-2 d-flex align-items-center">
    //           <CountUp
    //             start={0}
    //             end={50}
    //             decimals={3}
    //             duration={1}
    //             suffix={"€"}
    //             style={{ fontSize: "1.6rem" }}
    //           />
    //         </h3>
    //       </Col>
    //     </Row>
    //   </CardBody>
    // </Card>
  );
};
